import { TileCheckboxGroup } from '@kizi/comparator-components';
import {
  FilterQueryTriplePlay,
  generateFiltersTriplePlay,
  useField,
  useFormService,
  useWizardService,
} from '@kizi/comparator-core';
import React, { useEffect, useMemo, useState } from 'react';

const query = {
  category: 'general',
  name: 'productTypes',
};

export const PackageCheckbox = (props) => {
  const formService = useFormService();
  const wizardService = useWizardService();
  const service = useMemo(
    () => formService || wizardService,
    [formService, wizardService],
  );
  const field = useField(props._fieldName, service);
  const [selectedOptions, setSelectedOptions] = useState<string[]>(
    JSON.parse(field?.value as string),
  );
  const filtersField = useField('overview.filters', service);
  const defaultFiltersField = useField('overview.defaultFilters', service);
  const filterGraphQL = useField('overview.filterGraphQL', service);

  const options = useMemo(
    () => [
      {
        text: 'Internet',
        value: 'internet',
        hideCheckbox: true,
        checked: true,
        subText: '+',
      },
      {
        text: 'TV',
        value: 'television',
        checked: selectedOptions.includes('television'),
        onChange: () => handleChange('television'),
      },
      {
        text: 'Bellen',
        value: 'call',
        checked: selectedOptions.includes('call'),
        onChange: () => handleChange('call'),
      },
    ],
    [selectedOptions],
  );

  const filtersFieldValues = useMemo(
    () => JSON.parse(filtersField?.value as string),
    [filtersField?.value],
  );

  const defaultFiltersFieldValues = useMemo(
    () => JSON.parse(defaultFiltersField?.value as string),
    [defaultFiltersField?.value],
  );

  const filterGraphQLValues: FilterQueryTriplePlay[] = useMemo(
    () => JSON.parse(filterGraphQL?.value as string),
    [filterGraphQL?.value],
  );

  const filterAndJoinOptions = (options: string[]) =>
    options
      .map((option) => option.charAt(0).toUpperCase() + option.slice(1))
      .join(', ');

  const handleChange = (value: string) => {
    if (selectedOptions.includes(value)) {
      setSelectedOptions((p) => p.filter((option) => option !== value));
    } else {
      setSelectedOptions((p) => [...p, value]);
    }
  };

  useEffect(() => {
    const url = window.location.href;
    if (url.includes('tv')) {
      setSelectedOptions((p) => [...p, 'television']);
    }
    if (url.includes('alles-in-1')) {
      setSelectedOptions((p) => [...p, 'television', 'call']);
    }
  }, []);

  useEffect(() => {
    const augmentedOptions = [...selectedOptions];

    field?.set({ value: JSON.stringify(augmentedOptions) });
    filtersField?.set({
      value: JSON.stringify({
        ...filtersFieldValues,
        productTypes: augmentedOptions,
      }),
    });

    defaultFiltersField?.set({
      value: JSON.stringify({
        ...defaultFiltersFieldValues,
        productTypes: augmentedOptions,
      }),
    });

    filterGraphQL?.set({
      value: JSON.stringify(
        generateFiltersTriplePlay(filterGraphQLValues, [
          { ...query, value: filterAndJoinOptions(augmentedOptions) },
        ]),
      ),
    });
  }, [selectedOptions]);

  if (!field || !filtersField || !defaultFiltersField) return null;

  const checkboxProps = { ...props, options };

  return <TileCheckboxGroup {...checkboxProps} />;
};
